<template>
<div>
  <div class="upload-img">
    <span class="name">{{uploadImgName}}</span>

    <div class="demo-upload-list thumbnail" v-for="(item,i) in fileUploadList" :key="i">
      <template v-if="item.status === 'finished'">
        <div class="img">
          <img :src="`${uploadImgGlobelurl}${item.url}`" />
        </div>
        <div class="demo-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
        </div>
      </template>
      <template v-else>
        <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
      </template>
    </div>

     <Upload
      ref="upload"
      :show-upload-list="false"
      :default-file-list="fileUploadList"
      :on-success="handleSuccess"
      :format="uploadImgFormatType"
      :max-size="uploadImgMaxSize"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :before-upload="handleBeforeUpload"
      multiple
      type="drag"
      :action="uploadImgActionUrl"
      :data="uploadImgQueryData"
       :headers="headers"
      style="display: inline-block;"
    >
      <div class="default-img" v-if="isShowUploadBtn">
        <img :src="uploadImgDefaultUploadImg" alt />
      </div>
    </Upload>

  </div>
  <Modal :title="uploadImgPreviewTitle" v-model="visible">
            <img
              :src="`${uploadImgGlobelurl}/${imgUrl}`"
              v-if="visible"
              style="width: 100%"
            />
  </Modal>
</div>
</template>

<script>
import { Stream } from 'stream';
import { setTimeout } from 'timers';
export default {
  data() {
    return {
         headers:{'X-Access-Token': sessionStorage.token},
        uploadImgName: this.name,  //分类名称
        fileUploadList: this.uploadList,  //上传存储列表
        uploadImgGlobelurl: this.globelurl, //baseUrl
        uploadImgDefaultUploadImg: this.defaultUploadImg, //默认上传按背景图
        uploadImgFormatType: this.formatType, //上传文件类型
        uploadImgMaxSize: this.maxSize, //允许最大上传大小 单位KB
        uploadImgActionUrl: this.actionUrl, //上传服务器路径
        uploadImgQueryData: this.queryData, //上传服务器需要额外带的参数
        uploadImgPreviewTitle: this.previewTitle, //预览弹框标题
        uploadImgMaxFileNum: this.maxFileNum, //允许最大上传文件个数
        imgUrl: '',
        visible: false,
        isShowUploadBtn: true,
        imageMinWidth: this.minWidth,
        imageMinHeight: this.minHeight,
    };
  },
  props: {
      name: {
          type: [String],
          required: false,
          default: ''
      },
      uploadList: {
          type: [Array],
          required: false,
          default: []
      },
      globelurl: {
          type: [String],
          required: false,
          default: ''
      },
      defaultUploadImg: {
          required: false,
          default: '',
      },
      formatType: {
          type: [Array],
          required: false,
          default: ['jpg','jpeg','png']
      },
      maxSize: {
          type: [Number],
          required: false,
          default: 3
      },
      actionUrl: {
          type: [String],
          required: true
      },
      queryData: {
          type: [Object],
          required: false
      },
      previewTitle: {
          type: [String],
          required: false,
          default: '预览'
      },
      maxFileNum: {
          type:  [Number],
          required: false,
          default: 5
      },
      minWidth:{
          type: [Number],
          required: false,
          default: 0
      },
      minHeight:{
          type: [Number],
          required: false,
          default: 0
      }
  },
  // computed: {
  //   fileUploadList:  {
  //     get() {
  //       return this.uploadList
  //     },
  //     set() {
  //     }
  //   }
  // },
  mounted() {
    this.fileUploadList = this.$refs.upload.fileList;
    if(this.uploadImgMaxFileNum == this.fileUploadList.length) {
        this.isShowUploadBtn = false;
    }
  },
  methods: {
    handleView(url) {
      this.imgUrl = url;
      this.visible = true;
    },
    handleRemove(file) {
      this.$refs.upload.fileList.splice(this.$refs.upload.fileList.indexOf(file),1)
      this.fileUploadList.splice(this.fileUploadList.indexOf(file), 1);
      this.$emit('onMessage',{uploadImgName: this.uploadImgName, fileList: this.fileUploadList})
      this.isShowUploadBtn = true;
    },
    handleSuccess(res, file, fileList) {
        setTimeout(() => {
          file.url = res.result.pathList[0];
          this.fileUploadList = this.$refs.upload.fileList;
          this.$emit('onMessage',{uploadImgName: this.uploadImgName, fileList: this.fileUploadList})
          if(this.uploadImgMaxFileNum == this.fileUploadList.length) {
            this.isShowUploadBtn = false;
          }
        }, 1000);
    },
    handleBeforeUpload(file) {
        const check = this.$refs.upload.fileList.length < this.uploadImgMaxFileNum
        if (!check) {
            this.$Notice.warning({
                title: `抱歉，此分类最大允许上传${this.uploadImgMaxFileNum}张图片.`
            });
        }
        return check && this.checkImageWH(file, this.imageMinWidth, this.imageMinHeight);
    },
    handleFormatError(file) {
      console.log(this.uploadImgFormatType)
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: `文件${file.name}类型是错误的, 请选择${this.uploadImgFormatType.join('、').split('、')}类型`
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超过文件大小限制",
        desc: `文件${file.name}太大了，不得超过${this.uploadImgMaxSize/1024}M`
      });
    },
    //判断照片尺寸大小
    checkImageWH (file, width, height) {
      return new Promise((resolve, reject) => {
        let filereader = new FileReader();
        filereader.onload = e => {
          let src = e.target.result;
          var status = 0
          const image = new Image();
          image.onload = () => {
            if (width === 0 || height === 0) {
              resolve();
            }
            if (width && image.width < width) {
              this.$Message.error(
                '宽度不得小于' + width
              );
              status = -1
              reject();
            } else if (height && image.height < height) {
              this.$Message.error(
                '高度不得小于' + height
              );
              status = -1
              reject();
            } else {
              resolve();
            }
          };
          image.onerror = reject;
          image.src = src;
        };
        filereader.readAsDataURL(file);
      });
    }
  }
};
</script>
<style>
.default-img {
    width: 130px;
    height:130px;
    line-height: 130px;
}
.thumbnail {
  width: 100%;
  overflow: hidden;
  margin: 20px 0;
}
.sellBox .demo-upload-list:not(:nth-child(2)) {
  margin-left: 110px;
}
.sellBox .demo-upload-list + .ivu-upload {
  margin-left: 110px;
}
.thumbnail .name {
  width: 117px;
  float: left;
  text-align: right;
  margin-right: 10px;
}
.thumbnail .text {
  width: 130px;
  height: 130px;
  overflow: hidden;
}
.thumbnail .text img {
  width: 100%;
  height: 100%;
}
/* 上传图片开始 */
.sellBox .demo-upload-list {
  /* display: inline-block; */
  width: 200px;
  height: 150px;
  text-align: center;
  line-height: 150px;
  /* border: 1px solid transparent; */
  /* border-radius: 4px; */
  overflow: hidden;
  background: #fff;
  position: relative;
  /* box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2); */
  /* margin-right: 4px; */
}
.sellBox .demo-upload-list img {
  width: 100%;
  height: 100%;
}
.sellBox .demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.sellBox .demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}
.sellBox .demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
/* 上传图片结束 */
</style>


